import { PinMark } from "./PinMark";

const PHRASES = [
  "Recovery-Informed Concierge",
  "Western PA & Morgantown, WV",
  "Someone Who's Been There",
  "Narcan Trained & Equipped",
  "For Providers & Families",
  "Safe · Dignified · Reliable",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <section className="relative py-8 sm:py-10 bg-[#1F1D2B] overflow-hidden" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((p, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-6 sm:mx-9 text-2xl sm:text-3xl font-heading font-semibold tracking-tight text-white/70">
              {p}
            </span>
            <PinMark id={`marqPin${i}`} className="h-5 w-5 shrink-0 opacity-90" />
          </div>
        ))}
      </div>
    </section>
  );
};
